import { css } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2;
var Tabs = {
  List: {
    styles: {
      base: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        border-bottom: none;\n      "])))
    }
  },
  Tab: {
    styles: {
      base: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        height: 50px;\n        text-transform: uppercase;\n      "])))
    }
  }
};

export default Tabs;
